import { render, staticRenderFns } from "./PageLinks.vue?vue&type=template&id=44c88d26&scoped=true&"
import script from "./PageLinks.vue?vue&type=script&lang=js&"
export * from "./PageLinks.vue?vue&type=script&lang=js&"
import style0 from "./PageLinks.vue?vue&type=style&index=0&id=44c88d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c88d26",
  null
  
)

export default component.exports